// src/components/common/title.jsx
import React from 'react';
import { motion } from "framer-motion";
import { slideUp } from '../../utils/slideUp';

const Title = ({ 
  sectionName, 
  sectionTitle, 
  style, 
  sectionNameColor, 
  sectionTitleColor,
  sectionNameFontSize,
  sectionTitleFontSize,
  sectionNameFontWeight,
  sectionTitleFontWeight
}) => {

  return (
    <motion.div className={`section-title text-center ${style}`}
      initial="offscreen"
      whileInView="onscreen"
      variants={ slideUp(1) }
      viewport={{ once: true, amount: 0.4 }}
    >
      <span 
        className="d-block"
        style={{ 
          color: sectionNameColor || '#000', // Default to black
          fontSize: sectionNameFontSize || '16px', // Default to 16px
          fontWeight: sectionNameFontWeight || '500' // Default to 16px
        }} 
      >
        {sectionName}
      </span>
      
      <h2 
        style={{ 
          color: sectionTitleColor || '#333', // Default to dark gray
          fontSize: sectionTitleFontSize || '20px',
          fontWeight: sectionTitleFontWeight || '700',
        }}  
      >
        {sectionTitle}
      </h2>

    </motion.div>
  );
};

export default Title;



